import * as MailModuleAutoFocusManager from 'owa-mail-focus-manager/lib/mailModuleAutoFocusManager';
var composeComponents = [];
var composeAutoFocusRegistered = false;
var activeCompose = null;
export function registerComposeFocusManager(compose) {
    if (composeComponents.indexOf(compose) < 0) {
        composeComponents.push(compose);
        if (!composeAutoFocusRegistered) {
            MailModuleAutoFocusManager.registerComponent(MailModuleAutoFocusManager.FocusComponent.MailCompose, setFocusOnCompose);
            composeAutoFocusRegistered = true;
        }
    }
    activeCompose = compose;
}
export function unregisterComposeFocusManager(compose) {
    var index = composeComponents.indexOf(compose);
    if (index >= 0) {
        composeComponents.splice(index, 1);
        if (activeCompose == compose) {
            // Temporary solution since we only have at most 2 compose now.
            // TODO: Need to change when we support multiple floating compose.
            activeCompose = composeComponents[0];
        }
        if (composeAutoFocusRegistered && composeComponents.length == 0) {
            MailModuleAutoFocusManager.unregisterComponent(MailModuleAutoFocusManager.FocusComponent.MailCompose);
            composeAutoFocusRegistered = false;
        }
    }
}
function setFocusOnCompose() {
    if (activeCompose) {
        activeCompose.focus();
        return true;
    }
    else {
        return false;
    }
}
//# sourceMappingURL=composeFocusManager.js.map